import { MdNewspaper } from 'react-icons/md';
import { Resources } from '../../resource';
import { MainPage } from './main-page';

export const name = Resources.worldCupBreakingEvents;

export const list = MainPage;

export const icon = MdNewspaper;

export const options = { label: 'resource.worldCupBreakingEvents' };
